export default class Unexpected extends Error {
    constructor(message?: string) {
        super(message);  // Pass message to the base Error class
        this.name = 'Unexpected'  // Assign a custom error name

        // Fix the prototype chain (important for TypeScript inheritance)
        // Object.setPrototypeOf(this, Unexpected.prototype)
    }
}
